/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerBasketGetBasketItemsPost } from '../fn/basket/api-nursery-manager-basket-get-basket-items-post';
import { ApiNurseryManagerBasketGetBasketItemsPost$Params } from '../fn/basket/api-nursery-manager-basket-get-basket-items-post';
import { apiNurseryManagerBasketGetBasketItemsPost$Plain } from '../fn/basket/api-nursery-manager-basket-get-basket-items-post-plain';
import { ApiNurseryManagerBasketGetBasketItemsPost$Plain$Params } from '../fn/basket/api-nursery-manager-basket-get-basket-items-post-plain';
import { apiNurseryManagerBasketManageBasketItemsPost } from '../fn/basket/api-nursery-manager-basket-manage-basket-items-post';
import { ApiNurseryManagerBasketManageBasketItemsPost$Params } from '../fn/basket/api-nursery-manager-basket-manage-basket-items-post';
import { apiNurseryManagerBasketManageBasketItemsPost$Plain } from '../fn/basket/api-nursery-manager-basket-manage-basket-items-post-plain';
import { ApiNurseryManagerBasketManageBasketItemsPost$Plain$Params } from '../fn/basket/api-nursery-manager-basket-manage-basket-items-post-plain';
import { GetBasketItemsQueryResult } from '../models/get-basket-items-query-result';
import { ManageBasketItemCommandResult } from '../models/manage-basket-item-command-result';

@Injectable({ providedIn: 'root' })
export class BasketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerBasketGetBasketItemsPost()` */
  static readonly ApiNurseryManagerBasketGetBasketItemsPostPath = '/api/NurseryManager/Basket/GetBasketItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerBasketGetBasketItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketGetBasketItemsPost$Plain$Response(params?: ApiNurseryManagerBasketGetBasketItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBasketItemsQueryResult>> {
    return apiNurseryManagerBasketGetBasketItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerBasketGetBasketItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketGetBasketItemsPost$Plain(params?: ApiNurseryManagerBasketGetBasketItemsPost$Plain$Params, context?: HttpContext): Observable<GetBasketItemsQueryResult> {
    return this.apiNurseryManagerBasketGetBasketItemsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetBasketItemsQueryResult>): GetBasketItemsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerBasketGetBasketItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketGetBasketItemsPost$Response(params?: ApiNurseryManagerBasketGetBasketItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBasketItemsQueryResult>> {
    return apiNurseryManagerBasketGetBasketItemsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerBasketGetBasketItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketGetBasketItemsPost(params?: ApiNurseryManagerBasketGetBasketItemsPost$Params, context?: HttpContext): Observable<GetBasketItemsQueryResult> {
    return this.apiNurseryManagerBasketGetBasketItemsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetBasketItemsQueryResult>): GetBasketItemsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerBasketManageBasketItemsPost()` */
  static readonly ApiNurseryManagerBasketManageBasketItemsPostPath = '/api/NurseryManager/Basket/ManageBasketItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerBasketManageBasketItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketManageBasketItemsPost$Plain$Response(params?: ApiNurseryManagerBasketManageBasketItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageBasketItemCommandResult>> {
    return apiNurseryManagerBasketManageBasketItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerBasketManageBasketItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketManageBasketItemsPost$Plain(params?: ApiNurseryManagerBasketManageBasketItemsPost$Plain$Params, context?: HttpContext): Observable<ManageBasketItemCommandResult> {
    return this.apiNurseryManagerBasketManageBasketItemsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageBasketItemCommandResult>): ManageBasketItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerBasketManageBasketItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketManageBasketItemsPost$Response(params?: ApiNurseryManagerBasketManageBasketItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageBasketItemCommandResult>> {
    return apiNurseryManagerBasketManageBasketItemsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerBasketManageBasketItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerBasketManageBasketItemsPost(params?: ApiNurseryManagerBasketManageBasketItemsPost$Params, context?: HttpContext): Observable<ManageBasketItemCommandResult> {
    return this.apiNurseryManagerBasketManageBasketItemsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageBasketItemCommandResult>): ManageBasketItemCommandResult => r.body)
    );
  }

}
